/* SchemaForm view */
import React from "react";
import { Formik, Form } from "formik";
import ValuesObserver from "./SchemaForm.sub.ValuesObserver.view";
import SchemaRender from "./SchemaForm.sub.SchemaRender.view";
import "styles/css/util/schema_form/Form.css";


const SchemaFormView = ({
  formRef,
  componentRef,
  schema = [],
  appId,
  actionId,
  flowId,
  parentId,
  nodeId,
  executionId,
  initialValues = {},
  submitText = "Guardar",
  submitComponent,
  showSideSteps = true,
  isPreview,
  isDeveloper,
  isReadOnly = false,
  isCommentEnabled = false,
  onChange = () => { },
  onSubmit
}) => (
  <div>
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      onSubmit={onSubmit}>
      {({ values, setValues, setFieldValue }) => (
        <Form
          className="schema-form"
          ref={componentRef}
          onKeyDown={e => e.key === 'Enter' && e.preventDefault()} // Prevent form submission on Enter key press
        >

          {/* Observer to track form value changes */}
          <ValuesObserver
            onChange={onChange}
            values={values}
          />

          {/* Component that renders the form based on the schema */}
          <SchemaRender
            schema={schema}
            parentId={parentId}
            appId={appId}
            actionId={actionId}
            flowId={flowId}
            executionId={executionId}
            nodeId={nodeId}
            values={values}
            showSideSteps={showSideSteps}
            isDeveloper={isDeveloper}
            isReadOnly={isReadOnly}
            isCommentEnabled={isCommentEnabled}
            setFieldValue={setFieldValue}
            setValues={setValues}
          />

          <div className={(showSideSteps ? "pl-8 pr-4 my-1" : "px-5 mt-2 mb-1")}>
            {/* Render custom submit component if provided */
              submitComponent ?
                React.createElement(submitComponent, {
                  values: values,
                  setFieldValue: setFieldValue,
                }) : // Default submit button
                <button
                  type={isPreview ? "button" : "submit"}
                  className="btn btn-block btn-primary font-weight-bold"
                >
                  {submitText}
                </button>
            }
          </div>

        </Form>
      )}
    </Formik>

  </div>
)
export default SchemaFormView;